import type {
    TabBarIndicatorTargetConstantType,
    TabBarIndicatorTargetType
} from "./type";
import {
    getTabBarItemMeasures
} from "../item/stylesheet";

export const getTabBarIndicatorTarget = ({
    controlHeights,
    labelBehaviour,
    touchTargets,
    direction,
    listWidth,
    spaces,
    cell
}: TabBarIndicatorTargetConstantType): TabBarIndicatorTargetType | undefined => {
    if(!cell || listWidth <= 0) {
        return undefined;
    }

    const measures = getTabBarItemMeasures({
        controlHeights,
        labelBehaviour,
        touchTargets,
        spaces
    });

    const width = Math.min(measures.indicatorWidth, cell.width);

    const x = cell.x + (cell.width - width) / 2;

    return {
        y: labelBehaviour === "never" ? (cell.height - measures.indicatorHeight) / 2 : measures.paddingVertical,
        x: direction === "rtl" ? -(listWidth - x - width) : x,
        height: measures.indicatorHeight,
        width
    };
};
